import { Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { FORM_FIELDS } from 'src/const-data/form-field-mappings';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css'],
  standalone: false
})
export class ContractComponent implements OnChanges {
  @Output()
  readonly onStepBackward: EventEmitter<void> = new EventEmitter();

  @Input()
  contractForm!: FormGroup;
  @Input()
  projectId!: string;

  // temporary solution
  protected readonly version = '1.4.08';
  protected readonly fields = FORM_FIELDS.CONTRACT;

  private readonly destroyRef = inject(DestroyRef);
  private lastLoadedProjectId: string | null = null;
  private lastLoadedForm: FormGroup | null = null;

  constructor(private readonly dataService: DataService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectId'] || changes['contractForm']) {
      this.tryLoadProjectData();
    }
  }

  private tryLoadProjectData(): void {
    const id = (this.projectId ?? '').trim();
    const form = this.contractForm;
    if (!id || !form) return;
    if (this.lastLoadedProjectId === id && this.lastLoadedForm === form) return;

    this.lastLoadedProjectId = id;
    this.lastLoadedForm = form;

    this.dataService
      .readData(form, id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // Data loaded successfully
        },
        error: () => {
          // Error already handled by DataTransferService with toast notification
        }
      });
  }

  stepBack() {
    this.onStepBackward.emit();
  }
}
